module.exports = __webpack_public_path__ + "static/langojango-bulgarian-language-phrasebook-9e1e8200bcdcd1be32ab4e9df3bc1209.png";